import { createFileRoute } from '@tanstack/react-router';
import { Project } from '@shared/pages/project/Project';

export const Route = createFileRoute('/_app/project/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Project />;
}
